"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-restricted-imports
var styles_1 = require("@material-ui/core/styles");
// We must use our own version of makeStyles to ensure our styles are loaded *after* Material UI's default styles.
// Warning: When this function was added, only the production build suffered from broken styling.
var makeStyles = function (styles) {
    return (0, styles_1.makeStyles)(styles, { index: 1 });
};
exports.default = makeStyles;
